import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useApiStore from '../apiStore/useApiStore';
import { addressSuggestionStore } from './addressSuggestionStore';

const useAddressSuggestionStore = createStore({
  creator: addressSuggestionStore({
    key: import.meta.env.VITE_APP_SMARTYSTREETS_WEBSITE_KEY,
    useApiStore: lazyDependency(() => useApiStore),
  }),
  id: 'addressSuggestion',
  middlewares: {
    devtools: true,
  },
});

export default useAddressSuggestionStore;
